import {
  Typography,
  Box,
  Chip,
  useTheme,
  useMediaQuery
} from '@material-ui/core'
import PlaceOutlinedIcon from '@material-ui/icons/PlaceOutlined'
import StarIcon from '@material-ui/icons/Star'

import NoPictureDeafault from '../../../../assets/images/NoPictureDeafault.png'
import { gregorianToJalaaliWithHourMinuteAndSecond } from '../../../../helpers/date'
import { getTranslate, lang } from '../../../../localization'
import { BookingBasicDetails } from '../../../../types/bookingDetails'
import { ImageObject } from '../../../../types/image'
import useStyles from './styles/index.styles'

type Props = {
  data: BookingBasicDetails | undefined
  accommodationImages: ImageObject[] | undefined
}
const ReserveDetails = ({ data, accommodationImages }: Props) => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  return (
    <div className={classes.root}>
      <div className={classes.top}>
        <Typography variant="h4" className={classes.blackText}>
          {getTranslate('Reserve Details')}
        </Typography>
      </div>
      <div className={classes.main}>
        <div className={classes.card}>
          <img
            src={
              accommodationImages && accommodationImages.length > 0
                ? accommodationImages[0].url
                : NoPictureDeafault
            }
            alt="hotel"
            className={classes.image}
          />
          <Box className={classes.content}>
            <Box className={classes.left}>
              <div className={classes.header}>
                <Typography variant="subtitle1" className={classes.title}>
                  {lang === 'fa'
                    ? data?.accommodationNameTranslatedList[0].value
                    : data?.accommodationName}
                </Typography>
                <Typography variant="h5" className={classes.textColor}>
                  <PlaceOutlinedIcon
                    className={classes.icon}
                    fontSize="small"
                  />
                  {lang === 'fa'
                    ? data?.propertyAddressFA
                    : data?.propertyAddress}
                </Typography>
              </div>
              {!isMobile && (
                <div className={classes.payment}>
                  <Chip
                    size="small"
                    label={`${getTranslate('Reserve Number: ')} ${
                      data?.reservationNumber
                    }`}
                    className={classes.paymentChip}
                    variant="default"
                  />
                </div>
              )}
            </Box>
            {!isMobile && (
              <Box className={classes.right}>
                <div className={classes.stars}>
                  {Array.from({ length: 4 }).map((_, i) => (
                    <StarIcon
                      className={classes.icon}
                      key={i}
                      fontSize="small"
                    />
                  ))}
                </div>
                <div className={classes.bottom}>
                  <div className={classes.check}>
                    <Typography variant="h5" className={classes.dateLabel}>
                      {getTranslate('Reservation Type: ')}
                    </Typography>
                    <Typography variant="h5" className={classes.dateValue}>
                      {getTranslate(data?.reservationType || '')}
                    </Typography>
                  </div>
                  <div className={classes.check}>
                    <Typography variant="h5" className={classes.dateLabel}>
                      {getTranslate('Created At: ')}
                    </Typography>
                    <Typography variant="h5" className={classes.dateValue}>
                      {lang === 'en'
                        ? data?.createdAt
                        : gregorianToJalaaliWithHourMinuteAndSecond(
                            data?.createdAt || ''
                          )}
                    </Typography>
                  </div>
                </div>
              </Box>
            )}
          </Box>
        </div>
        {isMobile && (
          <Box className={classes.details}>
            <div className={classes.stars}>
              {Array.from({ length: 4 }).map((_, i) => (
                <StarIcon className={classes.icon} key={i} fontSize="small" />
              ))}
            </div>
            <div className={classes.bottom}>
              <div className={classes.check}>
                <Typography variant="h5" className={classes.dateLabel}>
                  {getTranslate('Reservation Type: ')}
                </Typography>
                <Typography variant="h5" className={classes.dateValue}>
                  {getTranslate(data?.reservationType || '')}
                </Typography>
              </div>
              <div className={classes.check}>
                <Typography variant="h5" className={classes.dateLabel}>
                  {getTranslate('Created At: ')}
                </Typography>
                <Typography variant="h5" className={classes.dateValue}>
                  {lang === 'en'
                    ? data?.createdAt
                    : gregorianToJalaaliWithHourMinuteAndSecond(
                        data?.createdAt || ''
                      )}
                </Typography>
              </div>
            </div>
          </Box>
        )}
      </div>
      <div className={classes.bottomm}>
        <Typography variant="h4" className={classes.blackText}>
          {getTranslate('Details')}
        </Typography>
        <div className={classes.grey}>
          <div className={classes.section}>
            <Typography variant="h6" className={classes.greyTex}>
              {getTranslate('CRS Status')}
            </Typography>
            <Typography variant="h6" className={classes.blackText}>
              {getTranslate(data?.crsStatus || '-')}
            </Typography>
          </div>
          <div className={classes.section}>
            <Typography variant="h6" className={classes.greyTex}>
              {getTranslate('PMS Status')}
            </Typography>
            <Typography variant="h6" className={classes.blackText}>
              {getTranslate(data?.pmsStatus || '-')}
            </Typography>
          </div>
          <div className={classes.section}>
            <Typography variant="h6" className={classes.greyTex}>
              {getTranslate('Number of Rooms')}
            </Typography>
            <Typography variant="h6" className={classes.blackText}>
              {data?.numberOfRooms}
            </Typography>
          </div>
          <div className={classes.section}>
            <Typography variant="h6" className={classes.greyTex}>
              {getTranslate('Number of Guest')}
            </Typography>
            <Typography variant="h6" className={classes.blackText}>
              {data?.numberOfGuest}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ReserveDetails
